import LanguageService from 'src/services/LanguageService';

const types = {
  SET_LANGUAGES: 'SET_LANGUAGES',
  SET_ACTIVE_LANGUAGE: 'SET_ACTIVE_LANGUAGE',
};
const state = {
  languages: [],
  activeLanguage: 'en'
};

const mutations = {
  [types.SET_ACTIVE_LANGUAGE]: (state, value) => {
    state.activeLanguage = value;
  },
  [types.SET_LANGUAGES]: (state, value) => {
    state.languages = value;
  }
};

const actions = {
  async getLanguages({ commit }) {
    let result = await LanguageService.get();
    commit(types.SET_LANGUAGES, result.data);
    let activeLanguage = result.data.find(l => l.primary === true);
    if(activeLanguage) {
      commit(types.SET_ACTIVE_LANGUAGE, activeLanguage);
    }
  },
  async setActiveLanguage({ commit, state }, lang) {
    let activeLanguage = state.languages.find(l => l.locale === lang);
    if(activeLanguage) {
      commit(types.SET_ACTIVE_LANGUAGE, lang);
    }
  }
};
const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
